import { render, staticRenderFns } from "./rainInofDialog.vue?vue&type=template&id=5b048d3c&scoped=true&"
import script from "./rainInofDialog.vue?vue&type=script&lang=js&"
export * from "./rainInofDialog.vue?vue&type=script&lang=js&"
import style0 from "./rainInofDialog.vue?vue&type=style&index=0&id=5b048d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b048d3c",
  null
  
)

export default component.exports